import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'warning' | 'success';
  size?: 'sm' | 'md' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  className = '',
  ...props 
}) => {
  const variantClasses = {
    primary: 'bg-theme/40 hover:bg-theme/60 text-theme',
    secondary: 'bg-gray-800/40 hover:bg-gray-700/60 text-gray-400',
    danger: 'bg-red-900/40 hover:bg-red-800/60 text-red-400',
    warning: 'bg-yellow-900/40 hover:bg-yellow-800/60 text-yellow-400',
    success: 'bg-green-900/40 hover:bg-green-800/60 text-green-400'
  };

  const sizeClasses = {
    sm: 'p-2 lg:p-4 text-[8px] lg:text-xs',
    md: 'p-3 lg:p-5 text-[9px] lg:text-sm',
    lg: 'p-4 lg:p-6 text-xs lg:text-base'
  };

  return (
    <button 
      className={`
        pixel-border font-bold uppercase tracking-widest transition-all
        ${variantClasses[variant]} 
        ${sizeClasses[size]}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};
